import React from "react";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faBolt,
  faRobot,
  faThumbsUp,
  faBriefcase,
  faColumns,
  faWandMagicSparkles,
} from "@fortawesome/free-solid-svg-icons";
import { useRouterCore } from "../../../cores/router";

/**
 * Bloque de introducción a productos (IA, redes, CRM, actividades) — estilo bento / SaaS moderno.
 */
export const HomeProductIntro: React.FC = () => {
  const intl = useIntl();
  const { routes } = useRouterCore();

  return (
    <section className="home-product-intro" aria-labelledby="home-intro-heading">
      <div className="home-product-intro__inner home-welcome-shell">
        <header className="home-product-intro__head">
          <span className="home-product-intro__eyebrow">
            <FontAwesomeIcon icon={faWandMagicSparkles} className="me-2" />
            <FormattedMessage id="app.home.intro.eyebrow" />
          </span>
          <div className="home-product-intro__title-wrap">
            <h2 id="home-intro-heading" className="home-product-intro__title">
              <FormattedMessage id="app.home.intro.title" />
            </h2>
          </div>
          <p className="home-product-intro__lead">
            <FormattedMessage id="app.home.intro.lead" />
          </p>
        </header>

        <div className="home-product-intro__bento">
          <div className="home-product-intro__grid">
          {/* 1. IA */}
          <article className="home-product-intro__card home-product-intro__card--ai">
            <div className="home-product-intro__card-glow" aria-hidden />
            <div className="home-product-intro__card-top">
              <div className="home-product-intro__card-icon home-product-intro__card-icon--ai">
                <FontAwesomeIcon icon={faRobot} />
              </div>
              <span className="home-product-intro__badge home-product-intro__badge--new">
                <FormattedMessage id="app.home.intro.ai.badge" />
              </span>
            </div>
            <h3 className="home-product-intro__card-title">
              <FormattedMessage id="app.home.intro.ai.title" />
            </h3>
            <p className="home-product-intro__card-desc">
              <FormattedMessage id="app.home.intro.ai.desc" />
            </p>
            <ul className="home-product-intro__pills">
              <li>
                <FormattedMessage id="app.home.intro.ai.point1" />
              </li>
              <li>
                <FormattedMessage id="app.home.intro.ai.point2" />
              </li>
            </ul>
            <Link
              to={`${routes.aiGeneration}?guide=ai`}
              className="home-product-intro__cta"
            >
              <span>{intl.formatMessage({ id: "app.home.intro.ai.cta" })}</span>
              <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
            </Link>
          </article>

          {/* 2. RRSS unificadas */}
          <article className="home-product-intro__card home-product-intro__card--social">
            <div className="home-product-intro__card-icon home-product-intro__card-icon--social">
              <FontAwesomeIcon icon={faThumbsUp} />
            </div>
            <h3 className="home-product-intro__card-title">
              <FormattedMessage id="app.home.intro.social.title" />
            </h3>
            <p className="home-product-intro__card-desc">
              <FormattedMessage id="app.home.intro.social.desc" />
            </p>
            <Link
              to={`${routes.socialPost}?guide=social`}
              className="home-product-intro__cta home-product-intro__cta--ghost"
            >
              <span>
                {intl.formatMessage({ id: "app.home.intro.social.cta" })}
              </span>
              <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
            </Link>
          </article>

          {/* 3. CRM */}
          <article className="home-product-intro__card home-product-intro__card--crm">
            <div className="home-product-intro__card-icon home-product-intro__card-icon--crm">
              <FontAwesomeIcon icon={faBriefcase} />
            </div>
            <h3 className="home-product-intro__card-title">
              <FormattedMessage id="app.home.intro.crm.title" />
            </h3>
            <p className="home-product-intro__card-desc">
              <FormattedMessage id="app.home.intro.crm.desc" />
            </p>
            <Link
              to={`${routes.businessBoard}?guide=deals`}
              className="home-product-intro__cta home-product-intro__cta--ghost"
            >
              <span>{intl.formatMessage({ id: "app.home.intro.crm.cta" })}</span>
              <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
            </Link>
          </article>

          {/* 4. Panel */}
          <article className="home-product-intro__card home-product-intro__card--activities">
            <div className="home-product-intro__card-icon home-product-intro__card-icon--activities">
              <FontAwesomeIcon icon={faColumns} />
            </div>
            <h3 className="home-product-intro__card-title">
              <FormattedMessage id="app.home.intro.activities.title" />
            </h3>
            <p className="home-product-intro__card-desc">
              <FormattedMessage id="app.home.intro.activities.desc" />
            </p>
            <Link
              to={`${routes.activityBoards}?guide=activities`}
              className="home-product-intro__cta home-product-intro__cta--ghost"
            >
              <span>
                {intl.formatMessage({ id: "app.home.intro.activities.cta" })}
              </span>
              <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
            </Link>
          </article>
          </div>

          <div className="home-product-intro__footnote">
            <FontAwesomeIcon icon={faBolt} className="me-2 text-primary" />
            <FormattedMessage id="app.home.intro.footnote" />
          </div>
        </div>
      </div>
    </section>
  );
};
